export enum ENavigationRoute {

    Chart = 'chart',
    Login = 'login',
    Config = 'config',
    Error = 'error',
    ResetPassword = 'resetPassword',
    Calendar = "calendar",
    Order = "order",
    Export = "export",
    Archives = "archives",
    News = "news",
    Home = Chart,
    Notifications = 'notifications'
}
